import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SiteHeader, SiteFooter, FloatingCta, useTheme } from './Legal';
import { SERVICE_BY_KEY } from './services';
import LeadForm from './LeadForm';
// ── DATA ──────────────────────────────────────────────────────────────────────

// Social / contact links
const SOCIAL_LINKS = {
  twitter: 'https://x.com/QireAgency',
  instagram: 'https://instagram.com/qireagency', 
  linkedin: 'https://linkedin.com/company/qireagency',
  upwork: 'https://www.upwork.com/freelancers/~0100bba04ce79cde7a',
  freelancer: 'https://www.freelancer.com/u/amoncheruiyothq'
};

// Where the real work lives — the personal portfolio is the front door now, this site is just the business entity
// TODO: replace with your actual portfolio domain
const PORTFOLIO_URL = 'https://bio.link/amoncheruiyothq';

const CONTACT_EMAIL = 'info@qireagency.com';

// Client reviews — public on the platforms they were left on
const REVIEWS = [
  { platform: 'Upwork', project: 'EA for MT4', period: 'Aug 30, 2023 - Sep 15, 2023',
    quote: "Amon's exceptional knowledge, unwavering commitment to going the extra mile, and his ever-readiness to assist make him a remarkable asset to any project.",
    client: 'Endorsed by client', tags: ['Collaborative', 'Accountable for Outcomes', 'Reliable'] },
  { platform: 'Freelancer.com', project: 'MT4 EA Live Trade Troubleshooting', period: '',
    quote: 'Exceptional and super skilled developer who understands the background of trading, hence has lots of good insight, tips and fruitful ideas.',
    client: 'Ales, Czech Republic', tags: ['C Programming', 'Software Architecture', 'MetaTrader'] },
  { platform: 'Freelancer.com', project: 'Complete MT4 Expert Advisor', period: '',
    quote: 'Very professional and really good at what he does. Highly recommended.',
    client: 'Luke Karel, Australia', tags: ['C Programming', 'Algorithm', 'Software Architecture', 'C++ Programming'] },
  { platform: 'Upwork', project: 'EA for MT4', period: 'Sep 29, 2023 - Jul 13, 2024',
    quote: '', client: 'Completed at a 5.0 rating', tags: ['MQL4', 'MetaTrader'] },
  { platform: 'Freelancer.com', project: 'Trading Bot', period: 'Jun 21, 2022 - Jan 2, 2024',
    quote: '', client: 'Completed at a 5.0 rating', tags: ['Python', 'Automation'] },
  { platform: 'Freelancer.com', project: 'MT4 Expert Advisor Development', period: 'Sep 13, 2025 - Nov 7, 2025',
    quote: '', client: 'Completed at a 5.0 rating', tags: ['MQL4', 'Strategy Build'] },
  { platform: 'Freelancer.com', project: 'Need Expert Advisor MT4 Entries Fixed', period: 'May 4, 2022 - Nov 29, 2025',
    quote: '', client: 'Completed at a 5.0 rating', tags: ['MQL4', 'Debugging'] },
];

const REV_CSS = `
.rev-head{display:flex;align-items:flex-end;justify-content:space-between;gap:2rem;margin-bottom:2.25rem}
.rev-arrows{display:flex;gap:.5rem;flex-shrink:0}
.rev-arrow{width:42px;height:42px;border-radius:var(--radius);display:flex;align-items:center;justify-content:center;background:var(--surface);color:var(--white);border:1px solid var(--border-bright);cursor:pointer;transition:background .2s,border-color .2s,color .2s,box-shadow .2s}
.rev-arrow:hover{background:var(--teal);border-color:var(--teal);color:var(--on-teal);box-shadow:0 0 22px -4px rgba(var(--glow),.5)}
.rev-scroll{display:flex;gap:1rem;overflow-x:auto;scroll-snap-type:x proximity;padding:4px 4px 1.25rem;margin:0 -4px;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch}
.rev-scroll::-webkit-scrollbar{display:none}.rev-scroll>*{scroll-snap-align:start}
.review-card{min-width:320px;max-width:340px;flex:0 0 auto;padding:1.6rem 1.5rem;background:var(--surface);border:1px solid var(--border);border-radius:var(--radius-lg);display:flex;flex-direction:column;transition:transform .22s,border-color .22s,box-shadow .22s}
.review-card:hover{transform:translateY(-3px);border-color:var(--teal-dim);box-shadow:0 16px 34px -14px rgba(var(--glow),.35)}
.rev-plat{align-self:flex-start;font:600 .72rem var(--font-display);letter-spacing:.13em;text-transform:uppercase;color:var(--teal);background:var(--teal-glow);border-radius:3px;padding:.3rem .6rem;margin-bottom:.9rem}
.rev-title{font:700 1.05rem/1.35 var(--font-display);color:var(--white);margin-bottom:.6rem}
.rev-stars{display:flex;gap:2px;color:var(--teal);margin-bottom:.8rem}
.rev-quote{font-size:.98rem;color:var(--white);line-height:1.7;font-style:italic;border-left:2px solid var(--teal);padding-left:.9rem;margin:.2rem 0 1.1rem}
.rev-client{font-size:.86rem;color:var(--white-dim)}.rev-period{font-size:.82rem;color:var(--white-dimmer)}
.rev-tags{display:flex;flex-wrap:wrap;gap:.35rem;margin-top:.75rem}
.rev-tags span{font:500 .74rem var(--font-display);letter-spacing:.04em;color:var(--white-dim);background:var(--surface-2);border:1px solid var(--border);border-radius:3px;padding:.2rem .5rem}
.rev-foot{margin-top:2rem;padding-top:1.75rem;border-top:1px solid var(--border)}
.rev-foot p{color:var(--white-dim);line-height:1.75;max-width:620px;margin:0 0 1.25rem}
.rev-links{display:flex;flex-wrap:wrap;gap:.75rem}
@media(max-width:700px){.review-card{min-width:82vw}.rev-head{flex-direction:column;align-items:flex-start;gap:1.25rem}}
@media(prefers-reduced-motion:reduce){.review-card{transition:none}}
@media(max-width:600px){
  .rev-head{margin-bottom:1.35rem;gap:.8rem}
  .rev-arrows{gap:.35rem}
  .rev-arrow{width:38px;height:38px}
  .rev-scroll{gap:.7rem;padding-bottom:.85rem}
  .review-card{min-width:min(84vw, 310px);max-width:min(84vw, 310px);padding:1.15rem 1rem}
  .rev-plat{font-size:.68rem;margin-bottom:.7rem}
  .rev-title{font-size:.98rem;line-height:1.35}
  .rev-quote{font-size:.88rem;line-height:1.6;padding-left:.7rem;margin-bottom:.85rem}
  .rev-client{font-size:.8rem}
  .rev-period{font-size:.75rem}
  .rev-tags{gap:.3rem;margin-top:.6rem}
  .rev-tags span{font-size:.66rem;padding:.18rem .4rem}
  .rev-foot{margin-top:1.4rem;padding-top:1.25rem}
  .rev-foot p{font-size:.9rem;line-height:1.65}
  .rev-links{gap:.55rem}
}

`;

// What we build — numbered groups; each item opens to its full description and tools
const CAPABILITY_GROUPS = [
  {
    label: 'For traders',
    items: [
      {
        key: 'bot',
        name: 'Trading bots & EAs',
        short: 'Automated strategies for MT4, MT5, cTrader.',
        desc: 'Your strategy turned into a fully automated system, backtested and optimized, with your risk rules built into the execution.',
        stack: ['MQL4/5', 'Python', 'C# (cTrader)'],
      },
      {
        key: 'indicator',
        name: 'Indicators & alerts',
        short: 'Built in Pine Script and MQL.',
        desc: 'Custom indicators and alert systems that put your analysis on the chart the way you read it.',
        stack: ['Pine Script', 'MQL4/5', 'C#'],
      },
      {
        key: 'ui',
        name: 'Trade assistant UIs',
        short: 'On-chart panels for sizing, orders and risk.',
        desc: 'On-chart panels for manual traders: position sizing, order placement, trade management and live risk in one view.',
        stack: ['MQL5', 'C#', 'Python'],
      },
    ],
  },
  {
    label: 'Crypto and DeFi',
    items: [
      {
        key: 'exchange',
        name: 'Binance & exchange bots',
        short: 'Grid, DCA and market-making bots.',
        desc: 'Automated trading on Binance and other major exchanges: grid, DCA, market-making and signal-driven bots, built around exchange API limits and your risk controls.',
        stack: ['Python', 'Exchange APIs', 'WebSockets'],
      },
      {
        key: 'arb',
        name: 'Arbitrage bots',
        short: 'Gaps across exchanges, DEXs and P2P.',
        desc: 'Scanners and bots that find and act on price gaps between exchanges, DEXs and P2P markets, with fees, slippage and transfer time priced in.',
        stack: ['Python', 'CEX / DEX', 'P2P'],
      },
      {
        key: 'contract',
        name: 'Smart contracts',
        short: 'Solidity contracts for tokens and staking.',
        desc: 'Smart contracts for tokens, staking and custom on-chain logic, written and tested on testnet before anything is deployed.',
        stack: ['Solidity', 'EVM'],
      },
    ],
  },
  {
    label: 'For firms and desks',
    items: [
      {
        key: 'hft',
        name: 'HFT & institutional systems',
        short: 'Low-latency execution and order routing.',
        desc: 'Low-latency execution engines, order routing and market data handling, scoped around your venues, latency targets and infrastructure.',
        stack: ['C++', 'C#', 'Python'],
      },
    ],
  },
];

const MARKETS = ['Forex', 'Crypto', 'Equities', 'Derivatives'];



// ── MAIN ──────────────────────────────────────────────────────────────────────
export default function QireAgency({ onSubmitLead }) {
  const [theme] = useTheme();
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState('hero');

  // Track active section purely for nav link styling
  useEffect(() => {
    const sections = ['hero', 'capabilities', 'reviews', 'contact'];
    const observers = [];
    sections.forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveSection(id); },
        { threshold: 0.3 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach(o => o.disconnect());
  }, []);

  // Which capability is expanded (one at a time, like an FAQ)
  const [openCap, setOpenCap] = useState('bot');

  const isDark = theme === 'dark';

  // Plausible analytics
  useEffect(() => {
    // Plausible Analytics
    const script = document.createElement('script');
    script.defer = true;
    script.dataset.domain = 'qireagency.com';
    script.src = 'https://plausible.io/js/script.js';
    document.head.appendChild(script);

    window.plausible = window.plausible || function() { 
      (window.plausible.q = window.plausible.q || []).push(arguments) 
    };

    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  useEffect(() => {
  document.documentElement.setAttribute('data-theme', theme);
}, [theme]);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior:'smooth', block:'start' });
  };

  const location = useLocation();
  useEffect(() => {
    const id = location.state && location.state.scrollTo;
    if (id) setTimeout(() => go(id), 80);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // Reviews carousel: three copies of the list, recentred after each scroll settles,
  // so dragging or paging past either end just keeps going.
  const revScrollRef = useRef(null);
  const revSettle = useRef(null);
  useEffect(() => {
    const el = revScrollRef.current;
    if (!el) return undefined;
    const oneSet = () => el.scrollWidth / 3;
    const recentre = () => { el.scrollLeft = oneSet(); };
    const raf = requestAnimationFrame(recentre);
    const onScroll = () => {
      clearTimeout(revSettle.current);
      revSettle.current = setTimeout(() => {
        const w = oneSet();
        if (el.scrollLeft < w * 0.5) el.scrollLeft += w;
        else if (el.scrollLeft > w * 1.5) el.scrollLeft -= w;
      }, 160);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recentre);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(revSettle.current);
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', recentre);
    };
  }, []);

  const pageReviews = (dir) => {
    const el = revScrollRef.current;
    if (!el) return;
    const card = el.querySelector('.review-card');
    const step = card ? card.getBoundingClientRect().width + 16 : 340;
    el.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  const trackEvent = (eventName, props = {}) => {
    if (window.plausible) {
      window.plausible(eventName, { props });
    }
  };

  const NAV = [['capabilities','What we build'],['contact','Contact']];

  // Social icons (inline SVG)
  
  return (
      <div style={{ background:'var(--black)', minHeight:'100vh' }}>



            {/* ── NAV ── */}
      <SiteHeader current={activeSection === 'contact' ? 'contact' : activeSection === 'capabilities' ? 'services' : activeSection === 'reviews' ? 'reviews' : null} onSection={go} />

      {/* HERO */}
      <div id="hero" className="q-hero">
        <h1 className="q-hero-title">
          <span className="teal">Financial Tech</span> Products
          <span className="line2">built for traders and businesses</span>
        </h1>

        <p className="q-hero-sub">
          We build trading bots, indicators, UIs and HFT systems across Forex, Crypto, Equities and Derivatives, in PineScript, MQL4/5, Python, C++ and C#.
        </p>

        <div className="q-hero-actions">
          <button type="button" className="q-btn-primary" onClick={() => { trackEvent('CTA Click', { button: 'Book a Call (Hero)' }); go('contact'); }}>Book a Call</button>
          <a href={PORTFOLIO_URL} target="_blank" rel="noopener noreferrer" className="q-btn-secondary" style={{textDecoration:'none', display:'inline-flex', alignItems:'center'}} onClick={() => trackEvent('CTA Click', { button: 'Visit Portfolio' })}>Visit Portfolio ↗</a>
        </div>

        <button className="q-portal-hint" onClick={() => { trackEvent('CTA Click', { button: 'Portal Login (Hint)' }); navigate('/portal'); }}>
          Existing client? <span>Access your portal →</span>
        </button>

        <div className="q-hero-platforms">
          <span>Available on</span><div className="q-hero-sep"/>
          <a href="https://www.upwork.com/freelancers/~0100bba04ce79cde7a" target="_blank" rel="noopener noreferrer">↗ Upwork</a>
          <div className="q-hero-sep"/>
          <a href="https://www.freelancer.com/u/amoncheruiyothq" target="_blank" rel="noopener noreferrer">↗ Freelancer</a> 
        </div>

        <div className="q-scroll-cue"><div className="q-scroll-line"/><span className="q-scroll-text">scroll</span></div>
      </div>

      {/* STRATEGY-TO-EA PROMO */}
      <div className="q-inner" style={{ marginBottom: '3rem' }}>
        <div className="sh-promo">
          <div>
            <span className="tag">New offer</span>
            <strong>Strategy Automation</strong>
            <p>Your written trading rules, built into a tested MT5 or MT4 Expert Advisor. Fixed price, fixed delivery date, backtest report included.</p>
          </div>
          <button className="q-btn-primary" onClick={() => { trackEvent('CTA Click', { button: 'Strategy Automation (Promo)' }); navigate('/strategy-automation'); }}>Explore offer →</button>
        </div>
      </div>

      {/* CAPABILITIES */}
      <section id="capabilities" className="q-section">
        <div className="q-inner">
          <div className="q-cap-layout">
            <aside className="q-cap-aside">
              <div className="q-eyebrow">Services</div>
              <h2 className="q-section-title">What we build</h2>
              <p className="q-section-desc">Every project starts from your trading logic.</p>
              <div className="q-markets">
                <span className="q-markets-label">Markets</span>
                <p className="q-markets-line">{MARKETS.join(' · ')}</p>
              </div>
            </aside>

            <div className="q-cap-groups">
              {CAPABILITY_GROUPS.map((g, gi) => (
                <div key={g.label} className="q-cap-group">
                  <div className="q-cap-group-head">
                    <span className="q-cap-num">{String(gi + 1).padStart(2, '0')}</span>
                    <span className="q-cap-group-label">{g.label}</span>
                  </div>
                  <div className="q-cap-list">
                    {g.items.map(c => {
                      const open = openCap === c.key;
                      return (
                        <div key={c.key} className={`q-cap${open ? ' open' : ''}`}>
                          <h3 className="q-cap-h">
                            <button
                              type="button"
                              id={`cap-btn-${c.key}`}
                              className="q-cap-trigger"
                              aria-expanded={open}
                              aria-controls={`cap-panel-${c.key}`}
                              onClick={() => {
                                setOpenCap(open ? null : c.key);
                                trackEvent('Capability Toggle', { item: c.name, action: open ? 'close' : 'open' });
                              }}
                            >
                              <span className="q-cap-title">
                                <span className="q-cap-name">{c.name}</span>
                                <span className="q-cap-short">{c.short}</span>
                              </span>
                              <span className="q-cap-icon" aria-hidden="true" />
                            </button>
                          </h3>
                          <div
                            id={`cap-panel-${c.key}`}
                            className="q-cap-panel"
                            role="region"
                            aria-labelledby={`cap-btn-${c.key}`}
                            aria-hidden={!open}
                          >
                            <div className="q-cap-panel-inner">
                              <p className="q-cap-desc">{c.desc}</p>
                              <div className="q-cap-stack">
                                <span className="q-cap-stack-label">Built with</span>
                                <ul className="q-chips">
                                  {c.stack.map(t => <li key={t} className="q-chip">{t}</li>)}
                                </ul>
                              </div>
                              {SERVICE_BY_KEY[c.key] && (
                                <div className="q-cap-actions">
                                  <button type="button" className="q-btn-primary" tabIndex={open ? 0 : -1}
                                    onClick={() => { trackEvent('CTA Click', { button: `${c.name} (Get a Quote)` }); navigate(`/services/${SERVICE_BY_KEY[c.key].slug}`); }}>Get a Quote →</button>
                                  {SERVICE_BY_KEY[c.key].projects.length > 0 && (
                                    <button type="button" className="q-btn-secondary" tabIndex={open ? 0 : -1}
                                      onClick={() => { trackEvent('CTA Click', { button: `${c.name} (View Projects)` }); navigate(`/services/${SERVICE_BY_KEY[c.key].slug}#projects`); }}>View Projects</button>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section id="reviews" className="q-section">
        <style>{REV_CSS}</style>
        <div className="q-inner">
          <div className="q-eyebrow">Reviews</div>
          <h2 className="q-section-title">What clients said afterwards</h2>
          <div className="rev-head">
            <p className="q-section-desc" style={{ marginBottom: 0 }}>Every review here is public and verified on the platform it was left on. Nothing is paraphrased, and nothing is hosted only by us.</p>
            <div className="rev-arrows">
              <button type="button" className="rev-arrow" aria-label="Previous reviews" onClick={() => pageReviews(-1)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
              </button>
              <button type="button" className="rev-arrow" aria-label="Next reviews" onClick={() => pageReviews(1)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
              </button>
            </div>
          </div>

          <div className="rev-scroll" ref={revScrollRef}>
            {[...REVIEWS, ...REVIEWS, ...REVIEWS].map((r, i) => (
              <div key={`${r.project}-${i}`} className="review-card" aria-hidden={i < REVIEWS.length || i >= REVIEWS.length * 2 ? true : undefined}>
                <div className="rev-plat">{r.platform}</div>
                <div className="rev-title">{r.project}</div>
                <div className="rev-stars" aria-label="5 out of 5 stars">{[0, 1, 2, 3, 4].map(n => <span key={n}><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg></span>)}</div>
                {r.quote && <p className="rev-quote">{r.quote}</p>}
                <div style={{ marginTop: 'auto' }}>
                  <div className="rev-client">{r.client}</div>
                  {r.period && <div className="rev-period">{r.period}</div>}
                  <div className="rev-tags">{r.tags.map(t => <span key={t}>{t}</span>)}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="rev-foot">
            <p>The full job history, the completed portfolio pieces and the 100% job success record live on the profiles themselves.</p>
            <div className="rev-links">
              <a href={SOCIAL_LINKS.upwork} target="_blank" rel="noopener noreferrer" className="q-btn-primary" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
                onClick={() => trackEvent('CTA Click', { button: 'Upwork profile (Reviews)' })}>Upwork profile ↗</a>
              <a href={SOCIAL_LINKS.freelancer} target="_blank" rel="noopener noreferrer" className="q-btn-secondary" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
                onClick={() => trackEvent('CTA Click', { button: 'Freelancer.com profile (Reviews)' })}>Freelancer.com profile ↗</a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="q-section alt">
        <div className="q-inner">
          <div className="q-contact-layout">
            <div>
              <div className="q-eyebrow">Get in Touch</div>
              <h2 className="q-contact-headline">Need a custom build?<br/><span className="teal">Let's talk.</span></h2>
              <p className="q-contact-para">Tell us what you need built. We can scope a custom EA, indicator or trade panel around your workflow. Send your details, then share them the way that suits you: a document or recording after an NDA, a call, or in writing.</p>
              <div className="q-channels">
                {[['Email',CONTACT_EMAIL,`mailto:${CONTACT_EMAIL}`],['Upwork','View portfolio','https://www.upwork.com/freelancers/~0100bba04ce79cde7a'],['Freelancer','View portfolio','https://www.freelancer.com/u/amoncheruiyothq']].map(([type,val,href]) => (
                  <a key={type} href={href} target={href.startsWith('mailto')?'_self':'_blank'} rel="noopener noreferrer" className="q-channel">
                    <span className="q-ch-type">{type}</span><span className="q-ch-val">{val}</span><span className="q-ch-arrow">→</span>
                  </a>
                ))}
              </div>
            </div>
            <div>
              <LeadForm onSubmitLead={onSubmitLead} variant="q" formName="Landing page contact form" source="Website" track={trackEvent} />
            </div>
          </div>
        </div>
      </section>

<FloatingCta label="Book a Call" onClick={() => { trackEvent('CTA Click', { button: 'Book a Call (Floating)' }); go('contact'); }} hideOn={['contact', 'site-footer']} />

      {/* FOOTER */}
        <SiteFooter onSection={go} />
    </div>
  );
}